import { ChangeEvent } from 'react';
import cx from 'classnames';
import { CaretIcon } from 'src/components/Icons/icons';
import { SUPPORTED_LANGUAGES } from 'src/i18n';
import { useTranslation } from 'react-i18next';

export type LanguageSelectProps = {
    className?: string;
    selectClassName?: string;
    caretClassName?: string;
    labelKey?: string;
};

export const LanguageSelect = ({
    className,
    selectClassName,
    caretClassName,
    labelKey = 'account.languageLabel',
}: LanguageSelectProps) => {
    const { t, i18n } = useTranslation();
    const languageEntries = Object.entries(SUPPORTED_LANGUAGES);
    const selectedLanguage = i18n.resolvedLanguage || i18n.language;

    const handleLanguageChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        if (value && value !== i18n.language) {
            i18n.changeLanguage(value);
        }
    };

    return (
        <div className={cx('relative inline-flex group', className)}>
            <select
                aria-label={t(labelKey)}
                className={cx(
                    'primary-btn-small cursor-pointer appearance-none pr-8 pl-3',
                    selectClassName,
                )}
                value={selectedLanguage}
                onChange={handleLanguageChange}
            >
                {languageEntries.map(([code, { label }]) => (
                    <option key={code} value={code} className="text-woodyBrown">
                        {label}
                    </option>
                ))}
            </select>
            <span
                className={cx(
                    'pointer-events-none absolute inset-y-0 right-3 flex items-center',
                    caretClassName,
                )}
            >
                <span className="relative w-3 h-3 text-woodyBrown group-hover:text-white">
                    <CaretIcon />
                </span>
            </span>
        </div>
    );
};
